import React from 'react';
import { useTranslation } from 'react-i18next';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { About } from '../pages/about';
import { Imprint } from '../pages/imprint';
import { Privacy } from '../pages/privacy';
import { Error404 } from '../pages/404';
import { TermsAndConditions } from '../pages/termsAndConditions';

const router = createBrowserRouter([
  {
    path: '/about/*',
    element: <About />,
  },
  {
    path: '/imprint/*',
    element: <Imprint />,
  },
  {
    path: '/privacy/*',
    element: <Privacy />,
  },
  {
    path: '/terms-and-conditions/*',
    element: <TermsAndConditions />,
  },
  {
    path: '*',
    element: <Error404 />,
  }
]);

export const App = () => {
  const { i18n } = useTranslation();

  return (
    <React.StrictMode>
      {i18n.exists('about.intendedUse.title') ? <RouterProvider router={router} /> : <Error404 />}
    </React.StrictMode>
  );
};
